module.exports = __webpack_public_path__ + "static/media/Justice.4e91f288.png";